<template>
    <div class="table_checkbox_container">
        <div class="table_checkbox">
            <div class="table_select_checkbox" :class="{active: isActive}" @click="$emit('change', !isActive)">

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableSelectCheckbox',
    props: ['checkboxId'],
    props: {
        isChecked: {
            type: Boolean,
            required: true
        },
        checkboxId: {
            type: String,
            required: true
        }
    },
    mounted(){
        this.val = this.isChecked
    },
    components: {},
    data(){
        return {}
    },
    computed: {
        isActive(){
            return this.isChecked
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.table_checkbox_container{
    display: flex;
    align-items: center;
    min-height: 42px;
    user-select: none;
    .table_checkbox{
        display: flex;
        align-items: center;
        justify-content: center;
        .table_select_checkbox{
            width: 20px;
            height: 20px;
            border: 2px solid $grey-light;
            display: block;
            border-radius: 4px;
            cursor: pointer;
            transition: .15s all;
        }
        .active{
            position: relative;
            border-color: $info;
            &:after{
                content: "";
                position: absolute;
                width: 12px;
                height: 12px;
                background-color: $info;
                display: block;
                top: 2px;
                left: 2px;
                border-radius: 2px;
            }
        }
    }
}
</style>